import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import './ContactPage.css';
import logo from "../assets/bg-remover-logo.png"
function ContactPage() {
  const [formData, setFormData] = useState({
    user_name: '',
    user_email: '',
    user_phone: '',
    user_subject: '',
    user_message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Simple validation
    if (!formData.user_name || !formData.user_email || !formData.user_message) {
      setSubmitStatus('Please fill in all required fields');
      return;
    }

    setIsSubmitting(true);
    setSubmitStatus('');

    try {
      // EmailJS configuration
      const serviceId = 'service_7tvy30n';
      const templateId = 'template_k715vet';
      const publicKey = 'wg08qUvWKswBLBb30';

      // Send email using EmailJS
      const result = await emailjs.send(
        serviceId,
        templateId,
        formData,
        publicKey
      );

      console.log('Email sent successfully:', result);
      setSubmitStatus('Thank you for your message! We will get back to you soon.');

      // Reset form
      setFormData({
        user_name: '',
        user_email: '',
        user_phone: '',
        user_subject: '',
        user_message: ''
      });

    } catch (error) {
      console.error('Error sending email:', error);
      setSubmitStatus('Sorry, there was an error sending your message. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contact-page">
      {/* Hero Section */}
      <section className="contact-hero">
        <div className="container">
          <div className="hero-content">
            <h1 className="hero-title">Get In Touch</h1>
            <p className="hero-subtitle">Ready to start your sports journey? We're here to help you achieve your goals.</p>
            <div className="hero-stats">
              <div className="stat-item">
                <span className="stat-number">500+</span>
                <span className="stat-label">Athletes Trained</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">15+</span>
                <span className="stat-label">Sports Disciplines</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">24/7</span>
                <span className="stat-label">Support Available</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Information Section */}
      <section className="contact-info-section">
        <div className="container">
          <h2 className="section-title">Contact Information</h2>
          <div className="contact-info-grid">
            <div className="contact-card">
              <div className="contact-icon">📞</div>
              <h3>Phone</h3>
              <p>
                📞
                <a className='numberAnchorTag' href='tel:+919414050348'>+91-9414050348</a>
              </p>
              {/* <p>+91-98870 49492</p> */}
              <span className="contact-note">Available 24/7 for urgent inquiries</span>
            </div>
            <div className="contact-card">
              <div className="contact-icon">✉️</div>
              <h3>Send Email</h3>
              <p
                onClick={() =>
                (window.location.href =
                  "mailto:askmesportsalliance@gmail.com?subject=Inquiry%20About%20Sports%20Program&body=Hi%20ASK%20ME%20Sports%20Team,%0AI%20would%20like%20to%20know%20more%20about%20your%20training%20programs.")
                }
                style={{ color: "#0078ff", cursor: "pointer", textDecoration: "none" }}
              >
                askmesportsalliance@gmail.com
              </p>
              <span className="contact-note">We respond within 2 hours</span>
            </div>
            {/* <div className="contact-card">
              <div className="contact-icon">📍</div>
              <h3>Office</h3>
              <p>📍 36 / B Lane No.5 dharm park shyam nagar-2 Rajasthan/Jaipur - 302019</p>
              <p>Sodala, Jaipur-302019 (Raj.) INDIA</p>
              <span className="contact-note">Visit us Monday to Saturday</span>
            </div> */}
            <div className="contact-card">
              <div className="contact-icon">🏢</div>
              <h3>Corporate Office</h3>
              <a style={{ textDecoration: "none" }} href="https://maps.app.goo.gl/SjwiibSW1NRNPBij9" target="_blank">
                <p>📍 36 / B Lane no.5 Dharm Park, Shyam Nagar-2, Jaipur - 302019</p>
              </a>

              {/* <p>Gopalpura Byepass, Jaipur-302019</p> */}
              <span className="contact-note">Business hours: 9 AM - 6 PM</span>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Form Section */}
      <section className="contact-form-section">
        <div className="container">
          <div className="form-container">
            <div className="form-content">
              <h2 className="form-title">Send Us a Message</h2>
              <p className="form-subtitle">Have questions about our programs? Want to schedule a consultation? We'd love to hear from you!</p>

              <form className="contact-form" onSubmit={handleSubmit}>
                <div className="form-row">
                  <div className="form-group">
                    <input
                      type="text"
                      name="user_name"
                      value={formData.user_name}
                      onChange={handleInputChange}
                      required
                      placeholder="Your Full Name"
                      className="form-input"
                    />
                  </div>
                  <div className="form-group">
                    <input
                      type="email"
                      name="user_email"
                      value={formData.user_email}
                      onChange={handleInputChange}
                      required
                      placeholder="Your Email Address"
                      className="form-input"
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <input
                      type="tel"
                      name="user_phone"
                      value={formData.user_phone}
                      onChange={handleInputChange}
                      placeholder="Your Phone Number"
                      className="form-input"
                    />
                  </div>
                  <div className="form-group">
                    <input
                      type="text"
                      name="user_subject"
                      value={formData.user_subject}
                      onChange={handleInputChange}
                      placeholder="Subject (e.g., Training Inquiry)"
                      className="form-input"
                    />
                  </div>
                </div>

                <div className="form-group">
                  <textarea
                    name="user_message"
                    value={formData.user_message}
                    onChange={handleInputChange}
                    required
                    rows="6"
                    placeholder="Tell us about your sports goals, training requirements, or any questions you have..."
                    className="form-textarea"
                  ></textarea>
                </div>

                <button type="submit" className="btn-primary" disabled={isSubmitting}>
                  {isSubmitting ? 'Sending Message...' : 'Send Message'}
                </button>

                {submitStatus && (
                  <div className={`submit-status ${submitStatus.includes('error') ? 'error' : 'success'}`}>
                    {submitStatus}
                  </div>
                )}
              </form>
            </div>

            <div className="form-sidebar">
              <div className="sidebar-card">
                <h3>Why Choose Us?</h3>
                <ul className="benefits-list">
                  <li>✅ Professional certified coaches</li>
                  <li>✅ State-of-the-art facilities</li>
                  <li>✅ Personalized training programs</li>
                  <li>✅ Flexible scheduling options</li>
                  <li>✅ Competitive pricing</li>
                  <li>✅ 24/7 support and guidance</li>
                </ul>
              </div>

              <div className="sidebar-card">
                <h3>Quick Response</h3>
                <p>We typically respond to all inquiries within 2 hours during business hours. For urgent matters, please call us directly.</p>
              </div>

              <div className="sidebar-card">
                <h3>Free Consultation</h3>
                <p>Book a free consultation to discuss your training needs and goals. No obligation, just expert advice.</p>
                <button className="btn-secondary">Book Free Consultation</button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 📍 Location Map Section */}
      <section className="map-section">
        <div className="container">
          <h2 className="section-title">Our Location</h2>
          <p className="section-description">
            📍 36 / B Lane No.5, Dharm Park, Shyam Nagar-2, Jaipur - 302019
          </p>

          <div className="map-container">
            <iframe
              title="Ask Me Sports Alliance Location"
              src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3558.2136152668763!2d75.75659427543894!3d26.896714876656723!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjbCsDUzJzQ4LjIiTiA3NcKwNDUnMzMuMCJF!5e0!3m2!1sen!2sin!4v1762343644578!5m2!1sen!2sin"
              width="100%"
              height="450"
              style={{ border: "0", borderRadius: "10px" }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="faq-section">
        <div className="container">
          <h2 className="section-title">Frequently Asked Questions</h2>
          <div className="faq-grid">
            <div className="faq-item">
              <h3>What sports do you offer training for?</h3>
              <p>We offer comprehensive training for over 15 sports including badminton, tennis, table tennis, athletics, boxing, weightlifting, basketball, volleyball, cricket, and shooting.</p>
            </div>
            <div className="faq-item">
              <h3>Do you provide equipment?</h3>
              <p>Yes, we provide all necessary equipment for beginners. Advanced athletes can bring their own equipment or use our premium gear available for rent.</p>
            </div>
            <div className="faq-item">
              <h3>What are your training hours?</h3>
              <p>Our facilities are open from 5:00 AM to 10:00 PM, Monday through Sunday. We offer flexible scheduling to accommodate your busy lifestyle.</p>
            </div>
            <div className="faq-item">
              <h3>Do you offer online training?</h3>
              <p>Yes, we provide online classes and virtual coaching sessions. You can book pay-per-class sessions with our expert coaches from anywhere.</p>
            </div>
            <div className="faq-item">
              <h3>What is your pricing structure?</h3>
              <p>Our pricing varies by sport and program type. We offer competitive rates starting from ₹1,500/month. Contact us for detailed pricing information.</p>
            </div>
            <div className="faq-item">
              <h3>Do you have trial sessions?</h3>
              <p>Yes, we offer free trial sessions for all new members. This allows you to experience our training methods and facilities before committing.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer - Same as main page */}
      <footer className="footer">
        <div className="footer-background"></div>
        <div className="container">
          <div className="footer-content">
            <div className="footer-column">
              <h3 className="footer-title">About Us</h3>
              <p className="footer-text">
                We are committed to excellence in sports training and community building. Our comprehensive programs help athletes develop both physically and mentally.
                At our core, we believe sports are not just games — they are a way of life that teach discipline, teamwork, and resilience. From badminton and athletics to volleyball and sports meditation, we provide holistic training that strengthens both body and mind.
              </p>
            </div>
            <div className="footer-column">
              <h3 className="footer-title">Latest Posts</h3>
              <div className="footer-post">
                <div className="post-date">
                  <span className="day">15</span>
                  <span className="month">Fri</span>
                </div>
                <div className="post-content">
                  <h4 className="post-title">New Training Program Launched</h4>
                  <p className="post-excerpt">Advanced coaching techniques for professional athletes</p>
                </div>
              </div>
              <div className="footer-post">
                <div className="post-date">
                  <span className="day">04</span>
                  <span className="month">Fri</span>
                </div>
                <div className="post-content">
                  <h4 className="post-title">Championship Results Announced</h4>
                  <p className="post-excerpt">Outstanding performances in the latest tournament</p>
                </div>
              </div>
              <a href="#" className="view-more">View More...</a>
            </div>
            <div className="footer-column">
              <h3 className="footer-title">Quick Links</h3>
              <ul className="footer-links">
                <li><a href="/" className="footer-link">HOME</a></li>
                <li><a href="#" className="footer-link">ABOUT OUR WEBSITE</a></li>
                <li><a href="#" className="footer-link">SHOP</a></li>
                <li><a href="#" className="footer-link">GALLERY</a></li>
                <li><a href="/contact" className="footer-link active">CONTACT</a></li>
              </ul>
            </div>
            <div className="footer-column">
              <h3 className="footer-title">Contact Details</h3>
              <div className="contact-info">
                <div className="contact-item">📍 36/B Lane no.5 dharm park shyam nagar-2 Rajasthan/Jaipur - 302019</div>
                <div className="contact-item">📞 +91-9414050348</div>
                <div className="contact-item">✉️ askmesportsalliance@gmail.com</div>
                <div className="contact-item">🌐 www.askmesportsalliance.com</div>
                <div className="contact-item">🕐 7AM - 8PM</div>
              </div>
            </div>
          </div>
          <div className="footer-logo">
            <img src={logo} alt="ASK ME SPORTS ALLIANCE Logo" className="footer-logo-icon" />
            <span className="footer-logo-text">ASK ME SPORTS ALLIANCE</span>
          </div>
          <div className="footer-social">
            <span className="social-icon">f</span>
            <span className="social-icon">t</span>
            <span className="social-icon">in</span>
            <span className="social-icon">G+</span>
          </div>
          <div className="footer-copyright">
            Copyright © 2023 ASK ME SPORTS ALLIANCE. Building Future, Shaping Champions.
          </div>
        </div>
      </footer>
    </div>
  );
}

export default ContactPage;